// @flow
import React from 'react'
import { Card as FulcrumCard } from '@upgrowth/react-fulcrum'
import './Card.scss'

const Card = (props) =>  <FulcrumCard variant="dark" {...props}/>
export default Card